import { Spin } from 'antd';
import { Suspense, lazy } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import Layout from '../../../components/Layout';
import Menu from '../../../components/Layout/Menu';

const ReportViewContent = lazy(() => import('../../../components/Pages/Reports/[reportId]'));

export default function ReportView(): JSX.Element | null {
  document.title = `${process.env.REACT_APP_TITLE}: Report View page`;

  return (
    <Layout LeftMenu={Menu} transparent>
      <Suspense fallback={<Spin spinning indicator={<LoadingOutlined spin />} />}>
        <ReportViewContent />
      </Suspense>
    </Layout>
  );
}
